import React from "react";

import LegalLayout from "../LegalLayout";
import { Link } from "react-router-dom";

function MentionsLegales() {
  return (
    <LegalLayout title="Mentions Légales">
        <div>
          <h2 className="fs-4 mt-4">Éditeur du site</h2>
          <p>
            Le présent site est édité par :<br />
            <strong>SAS Autoformation</strong><br />
            Siège social : 182 RUE LAVOISIER, 57600 OETING France<br />
            SIRET : 97947361800010<br />
            Responsable de la publication : Muller Geoffrey<br />
            Contact : contact@auto-formations.fr | 03 87 88 47 74
          </p>

          <h2 className="fs-4 mt-4">Hébergement</h2>
          <p>
            Le site est hébergé par :<br />
            <strong>OVH SAS</strong><br />
            Adresse : 2, rue Kellermann, 59100 Roubaix <br />
            Téléphone : 09 72 10 10 07
          </p>

          <h2 className="fs-4 mt-4">Propriété intellectuelle</h2>
          <p>
            L’ensemble des contenus présents sur ce site (textes, images, logos, vidéos, documents, etc.) est la propriété exclusive de <strong>SAS Autoformation</strong> ou de ses partenaires. 
            Toute reproduction, représentation, modification, publication, transmission ou dénaturation, totale ou partielle, du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit, est interdite sans autorisation écrite préalable.
          </p>

          <h2 className="fs-4 mt-4">Responsabilité</h2>
          <p>
            <strong>SAS Autoformation</strong> s’efforce de fournir des informations exactes et à jour. Toutefois, nous ne pouvons garantir l’exactitude, la complétude ou l’actualité des informations diffusées sur le site. 
            En conséquence, l’utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.
          </p>

          <h2 className="fs-4 mt-4">Données personnelles</h2>
          <p>
            Pour toute information concernant la collecte et le traitement des données personnelles, veuillez consulter notre <Link to="/politique-confidentialite"> Politique de confidentialité</Link>.
          </p>

          <h2 className="fs-4 mt-4">Cookies</h2>
          <p>
            Le site peut utiliser des cookies nécessaires à son bon fonctionnement. Pour plus d’informations, veuillez consulter notre <Link to="/politique-cookies"> Politique de cookies</Link>.
          </p>

          <h2 className="fs-4 mt-4">Droit applicable</h2>
          <p>
            Les présentes mentions légales sont régies par le droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.
          </p>
        </div>

    </LegalLayout>
    
  );
}

export default MentionsLegales;